import React, { useEffect, useState } from 'react';
import Header from "./Header";
import Footer from "./Footer";
import API from "../services/api";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import styles from '../styles/ReservationPage.module.css';


export default function ReservationPage() {

    // DATE
    const [date, setDate] = useState('');

    // AVAILABLE SLOTS
    const [availableSlots, setAvailableSlots] = useState([]);

    // LOADING
    const [loadingSlots, setLoadingSlots] = useState(false);

    // FORM
    const [formData, setFormData] = useState({
        customer_name: '',
        phone: '',
        reservation_time: '',
        people_count: 1,
        email: '',
        reservation_date_time: ''
    });

    // FETCH AVAILABLE SLOTS
    useEffect(() => {

        if (!date) return;

        const fetchAvailableSlots = async () => {

            try {

                setLoadingSlots(true);

                const response = await API.get(
                    '/reservations/available-slots',
                    {
                        params: {
                            date
                        }
                    }
                );

                setAvailableSlots(response.data);

            } catch (err) {

                console.error(err);

            } finally {

                setLoadingSlots(false);

            }
        };

        fetchAvailableSlots();

    }, [date]);

    // HANDLE INPUT CHANGE
    const handleInputChange = (e) => {

        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // HANDLE TIME SLOT
    const handleTimeSelect = (time) => {

        setFormData((prev) => ({
            ...prev,
            reservation_time: time
        }));
    };

    // HANDLE SUBMIT
    const handleSubmit = async () => {
        const formatedDate = date.toLocaleDateString('en-CA');

        try {

            const response = await API.post(
                `/reservations`,
                {
                    ...formData,
                    reservation_date: formatedDate
                }
            );

            alert(response.data.message);

            // RESET FORM
            setFormData({
                customer_name: '',
                phone: '',
                reservation_time: '',
                people_count: 1,
                email: '',
                reservation_date_time: ''
            });

            // REFRESH SLOTS
            const updatedSlots = await API.get(
                '/reservations/available-slots',
                {
                    params: {
                        date
                    }
                }
            );

            setAvailableSlots(updatedSlots.data);

        } catch (err) {

            console.error(err);

            if (err.response) {
                alert(err.response.data.message);
            }
        }
    };

    // const getTodayString = () => {
    //     const today = new Date();
    //     return today.toISOString().split('T')[0]; // YYYY-MM-DD
    //     };

    // const handleDateChange = (e) => {
    //     const selectedDate = new Date(e.target.value);
    //     const dayOfWeek = selectedDate.getDay(); // 0 = Sunday

    //     if (dayOfWeek === 0) {
    //         alert("Sundays are not allowed!");
    //         e.target.value = date; // revert to previous valid date
    //         return;
    //     }

    //     setDate(e.target.value);
    // };

    return (
    <>
        <Header />
        <main className={styles.page}>
            <div className={styles.container}>
                <h1 className={styles.title}>Book A Table</h1>

                <div className={styles.bookingCard}>
                    {/* DATE PICKER SECTION */}
                    <div className={styles.section}>
                        <label className={styles.label}>Select Date</label>
                        <DatePicker
                            selected={date}
                            onChange={(date) => setDate(date)}
                            minDate={new Date()}
                            filterDate={(date) => date.getDay() !== 0}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Select a date"
                            isClearable
                            todayButton="Today"
                            className={styles.datePicker}
                            wrapperClassName="w-full"
                        />
                    </div>

                    {/* TIME SLOTS SECTION */}
                    <div className={styles.section}>
                        <h3 className={styles.label}>Available Times</h3>
                        <div className={styles.slotsGrid}>
                            {loadingSlots ? (
                                <p className={styles.loading}>Loading slots...</p>
                            ) : (
                                availableSlots.map((slot) => (
                                    <button
                                        key={slot.time}
                                        disabled={!slot.available}
                                        onClick={() => handleTimeSelect(slot.time)}
                                        className={`${styles.slotButton} ${
                                            formData.reservation_time === slot.time 
                                            ? styles.selectedSlot 
                                            : ''
                                        }`}
                                    >
                                        {slot.time}
                                    </button>
                                ))
                            )}
                        </div>
                    </div>

                    {/* FORM SECTION */}
                    <div className={`${styles.section} ${styles.formGrid}`}>
                        <input
                            type="text"
                            name="customer_name"
                            placeholder="Your Name"
                            value={formData.customer_name}
                            onChange={handleInputChange}
                            className={styles.input}
                        />

                        <input
                            type="text"
                            name="phone"
                            placeholder="Phone Number"
                            value={formData.phone}
                            onChange={handleInputChange}
                            className={styles.input}
                        />

                        <input
                            type="number"
                            name="people_count"
                            min="1"
                            max="10"
                            placeholder="Number of People"
                            value={formData.people_count}
                            onChange={handleInputChange}
                            className={styles.input}
                        />

                        <input 
                            type="email"
                            name="email"
                            placeholder="Your Email"
                            className={styles.input}
                            value={formData.email}
                            onChange={(handleInputChange)}
                        />

                        <input
                            type="text"
                            name="reservation_date_time"
                            value={formData.reservation_date_time}
                            onChange={handleInputChange}
                            autoComplete='off'
                            tabIndex="-1"
                            style={{
                                position: 'absolute',
                                left: '-9999px',
                                opacity: 0,
                                height: 0,
                                width: 0,
                                pointerEvents: 'none',
                                overflow: 'hidden',
                                zIndex: -1000
                            }}
                        
                        />
                    </div>

                    {/* SUBMIT BUTTON */}
                    <button 
                        className={styles.submitButton} 
                        onClick={handleSubmit}
                    >
                        Reserve Table
                    </button>
                </div>
            </div>
        </main>
        <Footer />
    </>
);
}